// extracted by mini-css-extract-plugin
export default {"root":"GdprConsent_root__wufsr"};